const developmentListComponent = document.querySelector('.development-list');
if (developmentListComponent) {
  let numToPreload = 0;
  let componentType = "";
  let getData = async function() {
    const countyField = document.querySelector('.county');
    const cityField = document.querySelector('.city');
    const developmentStatusField = document.querySelector('.development-status');
    const developmentListIdField = document.querySelector('.developments_list_id');
    const successMessage = document.querySelector('.rest-message--success').value;
    const errorMessage = document.querySelector('.rest-message--fail').value;
    const numToPreloadField = document.querySelector('.num-preload');
    const availabilityFilter = document.querySelector('.availability-filter');
    const pricingFilter = document.querySelector('.price-range-filter');

    if (countyField !== null && cityField !== null) {

      // if County is specified then component type is County
      if (countyField.value) {
        componentType = "county";
      // otherwise town/city, forthcoming and completed can ne handled the same way
      } else  {
        componentType = "city";
      }
    } else if (developmentListIdField) {
      componentType = 'list';
    } else {
      // throw error
    }
    if (numToPreloadField && !isNaN(numToPreloadField.value ))  {
      numToPreload = parseInt(numToPreloadField.value);
    }
    let URL = '';

    // check for Development list type, town/county  or generic list and get the data
    if (componentType === 'county' || componentType === 'city') {
      URL = `${APIPrefix.get()}/search_api/developments/list?county=${countyField.value}&city=${cityField.value}&status=${developmentStatusField.value}`;
    } else {
      URL = `${APIPrefix.get()}/search_api/developments/getbylist?id=${developmentListIdField.value}`;
    }
    if (availabilityFilter) {
      URL = URL + `&availability=${availabilityFilter.value}`;
    }
    if (pricingFilter) {
      URL = URL + `&pricing=${pricingFilter.value}`;
    }
    let data = APIUtils.getComponentData(developmentListComponent, URL, successMessage, errorMessage, 'fader');
    return data;
  };

  getData().then((response) => {
    if (componentType === 'county' || componentType === 'city') {
      if (response.data.items.length > 0) {
        if (componentType === 'county') {
          displayCountyDevelopmentList(response.data.items, 2, componentType, numToPreload);
        } else {
          displayTownDevelopmentList(response.data.items, 2, componentType, numToPreload);
        }
      } else {
        displayNoDevelopmentsMessage(developmentListComponent);
      }
    } else if ('counties' in response.data) {

      // need to check if there are more than one county/town and call appropriate display function
      if (response.data.counties.length > 0) {
          response.data.counties.forEach((county) => {
              let countyHeadingLi = document.createElement('li');
              countyHeadingLi.innerHTML = `<h2 class='dev-county-title'><a href="${county.countyUrl}">${county.county}</a></h2>`;
              developmentListComponent.appendChild(countyHeadingLi);
              displayCountyDevelopmentList(county.towns, 3, componentType, 0);
          });
        } else {
          displayNoDevelopmentsMessage(developmentListComponent);
        }
    }
  })
  .catch((e) => console.log(e));

  let getInfo = async function(developmentId) {
    let DEVELOPMENT_STATUS_VALUE = document.querySelector('.development-status').value;
    let infoResponse = await fetch(
      `${APIPrefix.get()}/search_api/developments/details?developmentId=${developmentId}&status=${DEVELOPMENT_STATUS_VALUE}`
    );
    if (!infoResponse.ok) {
      throw new Error(`HTTP error! status: ${infoResponse.status}`);
    }
    let info = await infoResponse.json();
    return info;
  };

  let getTableData = async function(dataSourcePageId) {
    try {
      const NUMB_PER_PAGE = document.querySelector('.num-per-page').value;
      let DEVELOPMENT_STATUS_VALUE = document.querySelector('.development-status').value;

      let response = await fetch(
        `${APIPrefix.get()}/search_api/properties?noOfItemsPerPage=${NUMB_PER_PAGE}&dataSourcePageId=${dataSourcePageId}&status=${DEVELOPMENT_STATUS_VALUE}`
      );
      if (response.status == 200) {
        let data = await response.json();
        return data;
      } else {
        throw new Error(response.status);
      }
    } catch (error) {
      console.log(error);
    }
  };

  let lazyloadDevelopment = function(developmentDiv) {
    let developmentId = developmentDiv.dataset.id;

    getInfo(developmentId).then((info) => {
      developmentDiv.innerHTML = populateDevelopmentInfo(info.data, developmentId);
      let wrap = developmentDiv.querySelector('.table-results-wrapper');
      let btn = developmentDiv.querySelector('.prop-table');
      if (btn) {
        getTableData(developmentId).then((response) => {
          populateDevelopmentProperties(response.data, wrap, developmentDiv);
        });
        btn.addEventListener('click', () => {
          wrap.classList.toggle('visible');
          btn.classList.toggle('open-tab');
          btn.setAttribute('aria-expanded', 
            `${(btn.getAttribute('aria-expanded') !== 'true').toString()}` 
          );
        });
      }
    })
    .catch((e) => console.log(e));

  };

  let handleIntersectList = function(entries, observer) {
    for (let entry of entries) {
      if (entry.isIntersecting) { // if we are intersecting with the observer for the empty block, then must populate it
        observer.unobserve(entry.target);
        lazyloadDevelopment(entry.target);
      }
    }
  };

  let displayCountyDevelopmentList = function(towns, headingLevel, componentType, numToPreload) {
    let preloaded = 0;
    towns.forEach((town, index) => {
      let townLi;
      let addTown = true;
      if (preloaded >= numToPreload) {
        townLi = document.createElement('li');
        townLi.innerHTML = `<h${headingLevel} class='city-title'><a href="${town.cityUrl}">${town.title}</a></h${headingLevel}>`;
      } else {
        let townLis = developmentListComponent.querySelectorAll('li');
        townLi = townLis[index];
        addTown = false;
      }
      if (town.developmentIds.length > 0) {
        town.developmentIds.forEach((id) => {
          if (preloaded >= numToPreload) {
            let devBlock = buildDevelopmentBlock(id); // create empty block with fader transition
            townLi.appendChild(devBlock.element);
            // add an observer to the empty block, so when intersected, we populate it.
            let observer = new IntersectionObserver(handleIntersectList, devBlock.options);
            observer.observe(devBlock.element);
          } else {
            // check for the property button and table
            // re-use code from Town List
            createPropertyTable(id);
          }
        });
      } else {
        displayNoDevelopmentsMessage(townLi);
      }
      if (addTown){
        developmentListComponent.appendChild(townLi);
      }
      preloaded = preloaded + 1;

    });
  };


  let displayTownDevelopmentList = function(towns, headingLevel, componentType, numToPreload) {
      let town = towns[0];
      let index = 0;
      let townLi;
      let addTown = true;
      let preloaded = 0;

      // if we're not preloading we need to create the LI
      if (numToPreload === 0) {
        townLi = document.createElement('li');
        townLi.innerHTML = `<h${headingLevel} class='city-title'></h${headingLevel}>`;
      } else {
        // get the LI
        let townLis = developmentListComponent.querySelectorAll('li');
        townLi = townLis[index];
        addTown = false;
      }
      if (town.developmentIds.length > 0) {
        town.developmentIds.forEach((id) => {
          // if we've skipped the preloaded developments then lazy load
          if (preloaded >= numToPreload) {
            let devBlock = buildDevelopmentBlock(id);
            townLi.appendChild(devBlock.element);

            let observer = new IntersectionObserver(handleIntersectList, devBlock.options);
            observer.observe(devBlock.element);
          } else {
            createPropertyTable(id);

            // increment preloaded developments
            preloaded = preloaded + 1;
          }
        });
      } else {
        displayNoDevelopmentsMessage(townLi);
      }
      if (addTown){
        developmentListComponent.appendChild(townLi);
      }
  };

  let createPropertyTable = function(id) {
    let devBlock = document.getElementById(id);

    // check for the property button and add property table
    let propertyButton = devBlock.querySelector('.prop-table');
    if (propertyButton) {

      // get the results table wrapper
      let tableResultsWrapper = devBlock.querySelector('.table-results-wrapper');

      let propertyListComponent =  `
        <div class="property-list-component alt-background">
          <input type="hidden" class="num-per-page" value="2">
          <input type="hidden" class="data-source-page-id" value="">
          <div class="table-wrapper">
          </div>
        </div>`;
      tableResultsWrapper.innerHTML = propertyListComponent;
      // create property table use timeout so we don't block
      setTimeout(() => {
    
        getTableData(id).then((response) => {
          populateDevelopmentProperties(response.data, tableResultsWrapper, devBlock);
        });
        propertyButton.addEventListener('click', () => {
          tableResultsWrapper.classList.toggle('visible');
          propertyButton.classList.toggle('open-tab');
          propertyButton.setAttribute('aria-expanded', 
            `${(propertyButton.getAttribute('aria-expanded') !== 'true').toString()}` 
          );
        });
      }, '100');

    } 

  };

  let displayNoDevelopmentsMessage = function(listComponent) {
    const messageDiv = document.createElement('div');
    messageDiv.innerHTML = document.querySelector('.no-developments').value;
    listComponent.appendChild(messageDiv);
  };
}